import { truncateHex } from '@lfg/core/lib';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { Box, Button, Menu, MenuItem, Stack, TableCell, TableRow, Typography } from '@mui/material';
import { format } from 'date-fns';
import React from 'react';
import { useNavigate } from 'react-router';

import { DataTable } from 'src/components/DataTable';
import { ProjectListItem } from 'src/global/schemas/project.schema';
import { colors } from 'src/global/styles/colors';

interface DraftListTableProps {
  nodeList: Array<ProjectListItem>;
  isLoading: boolean;
  page: number;
  limit: number;
}

const DraftListTable = (props: DraftListTableProps) => {
  const { nodeList, isLoading, page, limit } = props;
  const nagivate = useNavigate();
  const [menuState, setMenuState] = React.useState<{ anchorEl: null | HTMLElement; selectedId: string | null }>({
    anchorEl: null,
    selectedId: null,
  });

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>, id: string) => {
    setMenuState({ anchorEl: event.currentTarget, selectedId: id });
  };

  const handleClose = () => {
    setMenuState({ anchorEl: null, selectedId: null });
  };

  const handleEditDraft = () => {
    if (menuState.selectedId) {
      nagivate(`/core-sale/${menuState.selectedId}/edit`);
      handleClose();
    }
  };

  return (
    <>
      <DataTable
        isEmpty={!nodeList.length && !isLoading}
        skeletonRowCount={4}
        isLoading={isLoading}
        renderHeader={() => (
          <TableRow
            sx={{
              backgroundColor: colors.neutral06,
            }}>
            <TableCell
              rowSpan={3}
              sx={{
                paddingLeft: '56px',
              }}>
              Project Name
            </TableCell>
            <TableCell rowSpan={3}>Created Date</TableCell>
            <TableCell rowSpan={3}>Last Updated</TableCell>
            <TableCell colSpan={3}>Created By</TableCell>
          </TableRow>
        )}
        renderBody={() => (
          <>
            {nodeList.map((row, index) => (
              <TableRow key={row.id}>
                <TableCell>
                  <Stack direction={'row'} alignItems={'center'}>
                    <Typography fontSize={'14px'} width={'40px'}>
                      {(page - 1) * limit + index + 1}
                    </Typography>
                    <Typography fontSize={'14px'}>{row.name}</Typography>
                  </Stack>
                </TableCell>
                <TableCell>{format(new Date(row.createdAt), 'dd/MM/yyyy')}</TableCell>
                <TableCell>{format(new Date(row.updatedAt), 'dd/MM/yyyy H:mm')}</TableCell>
                <TableCell>
                  <Box width={'100%'} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Typography>{truncateHex(row.createdBy, 4)}</Typography>
                    <Button disableRipple onClick={e => handleClick(e, row.id)}>
                      <MoreHorizIcon sx={{ color: 'white' }} />
                    </Button>
                    <Menu
                      id={`menu-${row.id}`}
                      anchorEl={menuState.anchorEl}
                      open={Boolean(menuState.anchorEl && menuState.selectedId === row.id)}
                      onClose={handleClose}
                      sx={{
                        '& .MuiPaper-root': {
                          backgroundColor: 'black',
                          color: 'white',
                        },
                      }}
                      MenuListProps={{
                        sx: {
                          bgcolor: 'black',
                          color: 'white',
                          borderRadius: '8px',
                        },
                      }}>
                      <MenuItem onClick={handleEditDraft}>
                        <Box width={'100%'} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <BorderColorIcon
                            sx={{ width: '20px', height: '20px', color: 'white', marginRight: '12px' }}
                          />
                          <Typography fontSize={'14px'} fontWeight={400} lineHeight={'20px'}>
                            Edit Draft
                          </Typography>
                        </Box>
                      </MenuItem>
                    </Menu>
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </>
        )}
      />
    </>
  );
};

export { DraftListTable };
